import isBrowser from "~/kernel/browser/isBrowser";

export default function isServer() {
  return !isBrowser();
}
